import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeShapesIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M3.6 11.16L7.94 3.7L12.28 11.16H3.6ZM16.2 10.94C14.36 10.94 12.84 9.44 12.84 7.6C12.84 5.76 14.36 4.28 16.2 4.28C18.04 4.28 19.56 5.76 19.56 7.6C19.56 9.44 18.04 10.94 16.2 10.94ZM18.06 7.6C18.06 6.6 17.22 5.72 16.2 5.72C15.18 5.72 14.34 6.6 14.34 7.6C14.34 8.6 15.18 9.48 16.2 9.48C17.22 9.48 18.06 8.6 18.06 7.6ZM5.9 9.84H10L7.94 6.3L5.9 9.84ZM11.94 16.14L16.2 11.88L20.46 16.14L16.2 20.4L11.94 16.14ZM4.6 19.38V12.9H11.06V19.38H4.6ZM14 16.14L16.2 18.36L18.4 16.14L16.2 13.92L14 16.14ZM6.1 17.88H9.56V14.42H6.1V17.88Z" />
    </SvgIcon>
  );
});
